import {z} from "zod/v4-mini"

export type DataType = "FLOAT" | "VECTOR" | "RGBA"
export const dataTypeSchema = z.enum(["FLOAT", "VECTOR", "RGBA"])

export type FactorMode = "UNIFORM" | "NON_UNIFORM"
export const factorModeSchema = z.enum(["UNIFORM", "NON_UNIFORM"])
